import * as actionTypes from './actionTypes';



/**
 * Gives us a simplified rundown of all status keyed by mutationtypes
 * @param {import('./state.js').state} state
 */
export function statusSummary(state) {
  const { status } = state;

  const typeKeys = Object.keys(actionTypes);

  // They seem like they are ordered by index but just to make sure...
  return Object.fromEntries(
    Array.from(typeKeys, tk => [tk, status[`${tk}_Status`]?.status])
  );
}
